import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "PREPRIM",
  title: defineMessage({
    id: "fig.access.PREPRIM.title",
    defaultMessage: `Participation rate in organized learning (one year before the official primary entry age)`,
  }),
  caption: defineMessage({
    id: "fig.access.PREPRIM.caption",
    defaultMessage: `Three in four children attend pre-school the year before entering primary education`,
  }),
  source: defineMessage({
    id: "fig.access.PREPRIM.source",
    defaultMessage: `UIS database`,
  }),
};
